<template>
  <div class="login-header">
    <div class="main-top w">
      <div class="main-top-fl">
        <a href="/"> <img src="@/assets/images/home/logo1.png" alt="" /></a>
        <div class="spans">
          <span class="span-1">正见·正心·正品</span>
          <span>极联-F2S2B汽配供应链平台</span>
        </div>
      </div>
      <div class="main-top-fr">
        <span @click="addFavorite" class="spans">返回登录</span>
        <i></i>
        <span>客服热线：130-5208-5563</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    // 收藏
    addFavorite() {
      this.$router.push('/login')
      // var url = window.location
      // var title = document.title
      // var ua = navigator.userAgent.toLowerCase()
      // try {
      //   window.external.addFavorite(url, title)
      // } catch (e) {
      //   try {
      //     window.sidebar.addPanel(title, url, '')
      //   } catch (e) {
      //     alert('收藏失败，此操作被浏览器拒绝！\n请使用Ctrl+D进行收藏！')
      //   }
      // }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.login-header {
  border-bottom: 2px solid #377cf1;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main-top {
    display: flex;
    padding-top: 39px;
    padding-bottom: 20px;
    .main-top-fl {
      padding-top: 68px;
      display: flex;
      font-size: 14px;
      color: #787878;
      flex: 1;
      img {
        width: 122px;
        height: 34px;
      }
      .spans {
        padding-top: 17px;
        padding-left: 12px;
        letter-spacing: 4px;
        span:first-child {
          color: #b7b7b7;
          padding-right: 13px;
          letter-spacing: 9px;
        }
      }
    }
    .main-top-fr {
      margin-right: auto;
      padding-top: 84px;
      .spans {
        color: #377cf1;
        cursor: pointer;
      }
      // span {
      // cursor: pointer;
      // }
      // span:hover {
      //   color: #e90d0d;
      // }
      i {
        width: 0px;
        height: 14px;
        border: 1px solid #c2c2c2;
        opacity: 1;
        margin: 0 10px 0 11px;
      }
    }
  }
}
</style>